<template>
  <div class="module-header row-header line">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CModuleHeader",
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  props: {
    height: {
      type: Number,
      default: 5
    }
  },
  /////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  computed: {
    renderHeight: function() {
      return this.height + "vh";
    }
  }
}
</script>

<style lang="scss" scoped>
  .module-header {
    height: v-bind(renderHeight);
  }
</style>